export function setPageSeo({ title, description, canonical, ogType = "website" }) {
  const ensureTag = (selector, createFn) => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = createFn();
      document.head.appendChild(el);
    }
    return el;
  };

  if (title) {
    document.title = title;
  }

  if (description) {
    const desc = ensureTag('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    });
    desc.setAttribute("content", description);

    const ogDesc = ensureTag('meta[property="og:description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:description");
      return m;
    });
    ogDesc.setAttribute("content", description);
  }

  if (canonical) {
    const canonicalTag = ensureTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonicalTag.setAttribute("href", canonical);

    const ogUrl = ensureTag('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    });
    ogUrl.setAttribute("content", canonical);
  }

  if (title) {
    const ogTitle = ensureTag('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    });
    ogTitle.setAttribute("content", title);
  }

  const type = ensureTag('meta[property="og:type"]', () => {
    const m = document.createElement("meta");
    m.setAttribute("property", "og:type");
    return m;
  });
  type.setAttribute("content", ogType);
}
